namespace Gamification.Gamification {
    export class ProdottiEsperienzeClassiEditorColumns {
        static columnsKey = 'Gamification.ProdottiEsperienzeClassiEditor';
    }
}
